import { useQuery } from "@tanstack/react-query";
import { fetchPendingChanges } from "../api/fetchPendingChanges";

export const usePendingChanges = (type) => {
  return useQuery({
    queryKey: ["pendingChanges", type],
    queryFn: () => fetchPendingChanges(type),
    enabled: !!type,
    staleTime: 5000,
  });
};
